module.exports = __webpack_public_path__ + "static/media/13n.2a255fc7.png";